export default __webpack_public_path__ + "static/media/Flaticon2.76f38df3.woff";